import { IUser } from "@/api";
import { useAuth } from "@/contexts/auth/useAuth";
import { Avatar, Chip, ChipProps } from "@mui/material";
import { useMemo } from "react";

interface IProps extends ChipProps {
    /**
     * The user object
     */
    user?: IUser;
    /**
     * If this chip is used to display association with InsureScope
     *
     * @default false
     */
    insureScope?: boolean;
}

export const UserChip = ({ user, insureScope = false, ...props }: IProps) => {
    const { user: loggedInUser } = useAuth();

    const label = useMemo(() => {
        if (insureScope) {
            return "InsureScope";
        }

        if (!user) {
            return "Unknown";
        }

        if (loggedInUser?.id === user.id) {
            return "Me";
        }

        return user.email;
    }, [insureScope, user, loggedInUser?.id]);

    return (
        <Chip
            avatar={
                <Avatar
                    src={insureScope ? "/magnifying_glass.png" : undefined}
                />
            }
            label={label}
            color={insureScope ? "primary" : props.color}
            {...props}
        />
    );
};
